import { SelectorBase } from '../../Config/SelectorBase';
import { IUserColumns, IUserPortalDetails, IComingCourses } from './User';
import { IActivityModel } from '../Activity/Activity';

/* Selector represents the data
 * that needs to be displayed no update or delete should here
 * All of the updates and delete (data changes) should
 * be done via action in the reducer
 */
export class UserSelector extends SelectorBase {
  public static getUser() {
    const session = super.getDataSource();
    const UserData = session.User.all().first();
    return UserData as IUserColumns;
  }
  public static getUserFavoriteActivities() {
    const user = this.getUser();
    const session = super.getDataSource();
    const userFav = user.portalDetails
      ? user.portalDetails.courseFavorites
      : null;

    if (userFav !== null && userFav !== undefined) {
      const retArry: IActivityModel[] = session.Activity.all().toModelArray();

      return retArry.filter(
        a => userFav.indexOf(a.detailKursusId.toString()) >= 0
      );
    } else {
      return undefined;
    }
  }

  public static isShowOnlyUserIntrests() {
    return this.getUser().showInterests;
  }

  public static getUserComingCourses() {
    const user = this.getUser();
    const session = super.getDataSource();
    const userComing = user.portalDetails
      ? user.portalDetails.comingCourses
      : null;

    if (!userComing) {
      return [];
    }

    const retArry: IComingCourses[] = [];
    userComing.forEach(uc => {
      const act: IActivityModel = session.Activity.withId(
        uc.detailKursusId.toString()
      );
      if (act !== null) {
        // we need to get the courses even though we dont have it in the Portal
        uc.activity = act;
        retArry.push(uc);
      }
    });
    return retArry;
  }

  public static getUserInterests() {
    const user = this.getUser();
    return user.portalDetails ? user.portalDetails.topicInterests : undefined;
  }

  public static isUserFavorites(detailkursusId: number): boolean {
    const user = this.getUser();
    const favs = user.portalDetails
      ? user.portalDetails.courseFavorites
      : undefined;
    if (favs !== undefined) {
      return favs.indexOf(detailkursusId.toString()) !== -1;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/Entities/User/User.Selector.ts